import styles from '@styles/scss/common/_subTitle.module.scss';
const languageFiles = (require as any).context('public/locales', false, /\.json$/);

export default function SubTitle({
    siteName,
    currentLang
}: {
    siteName: string;
    currentLang: string;
}): JSX.Element {
    const languageFile = languageFiles(`./${currentLang}.json`);
    const title = languageFile.similar_title.replace('%SITE_NAME%', siteName);

    return (
        <>
            <h2 className={styles.container}>{title}</h2>
        </>
    );
}
